export function ContextMenuCursorIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className="menu-click-icon"
    >
      <path
        d="M9.37134 23.8858V5.6001L22.6285 18.8572H14.8571L14.3999 18.9715L9.37134 23.8858Z"
        fill="var(--bs-primary-alt)"
      />
      <path
        d="M19.7714 24.6857L15.6571 26.4L10.2856 13.7143L14.5142 12L19.7714 24.6857Z"
        fill="var(--bs-primary-alt)"
      />
      <path
        d="M14.7136 15.4497L12.606 16.3345L16.1452 24.7651L18.2528 23.8803L14.7136 15.4497Z"
        fill="var(--bs-primary)"
      />
      <path
        d="M10.5144 8.34277V21.1428L13.943 17.8285L14.4001 17.7142H19.8858L10.5144 8.34277Z"
        fill="var(--bs-primary)"
      />
    </svg>
  );
}

export function MailIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84 63" width="84" height="63" fill="var(--bs-bg-lvl1)">
      <defs>
        <linearGradient id="bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(240,240,240,.4)" />
          <stop offset="100%" stopColor="rgba(250,250,250,.4)" />
        </linearGradient>
        <filter id="cardShadow" x="-20%" y="-20%" width="140%" height="160%">
          <feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="rgba(0,0,0,0.3)" />
        </filter>
        <filter id="flapShadow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="2" />
        </filter>
      </defs>
      <rect x="12" y="8" width="60" height="39" fill="var(--bs-bg-lvl1)" />
      <rect x="12" y="8" width="60" height="39" fill="url(#bg)" stroke="var(--bs-bg-lvl1)" filter="url(#cardShadow)" />
      <path
        d="M42 31.1L71.7 8.36H12.3L42 31.1Z"
        fill="black"
        opacity="0.25"
        transform="translate(0 2)"
        filter="url(#flapShadow)"
      />
      <path d="M42 31.1L71.7 8.36H12.3L42 31.1Z" fill="var(--bs-bg-lvl1)" />
      <path d="M42 31.1L71.7 8.36H12.3L42 31.1Z" fill="white" opacity="0.6" />
    </svg>
  );
}

export function DragCursorIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="37"
      viewBox="0 0 32 37"
      fill="none"
      className="mail-file-cursor"
    >
      <rect x="15" y="20" width="12" height="12" stroke="var(--bs-primary)" strokeWidth="2" strokeDasharray="2 2" />
      <rect x="23.5" y="28.5" width="8" height="8" fill="var(--bs-primary-alt)" />
      <rect x="23.5" y="28.5" width="8" height="8" stroke="var(--bs-primary)" />
      <rect x="25" y="33" width="1" height="5" transform="rotate(-90 25 33)" fill="var(--bs-primary)" />
      <rect x="27" y="30" width="1" height="5" fill="var(--bs-primary)" />
      <path
        d="M9.37134 23.8858V5.6001L22.6285 18.8572H14.8571L14.3999 18.9715L9.37134 23.8858Z"
        fill="var(--bs-primary-alt)"
      />
      <path
        d="M19.7714 24.6857L15.6571 26.4L10.2856 13.7143L14.5142 12L19.7714 24.6857Z"
        fill="var(--bs-primary-alt)"
      />
      <path
        d="M14.7136 15.4497L12.606 16.3345L16.1452 24.7651L18.2528 23.8803L14.7136 15.4497Z"
        fill="var(--bs-primary)"
      />
      <path
        d="M10.5144 8.34277V21.1428L13.943 17.8285L14.4001 17.7142H19.8858L10.5144 8.34277Z"
        fill="var(--bs-primary)"
      />
    </svg>
  );
}
